import script from "./PromoLadder.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoLadder.vue?vue&type=script&setup=true&lang=js"

import "./PromoLadder.vue?vue&type=style&index=0&id=5a15535e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a15535e"]])

export default __exports__